export const LOCAL_STORAGE_ACCESS_TOKEN =
  "AWARE_TECHNOLOGY_STAFF_PORTAL_ACCESS_TOKEN";
export const LOCAL_STORAGE_REFRESH_TOKEN =
  "AWARE_TECHNOLOGY_STAFF_PORTAL_REFRESH_TOKEN";

export const ROLES = {
  ADMIN: "admin",
  TEACHER: "teacher",
  STUDENT: "student",
};

export const PERMISSIONS_FOT_ROUTES = {
  "/staff": [ROLES.ADMIN],
  "/settings": [ROLES.ADMIN],
};
